import { LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT, LOGIN_REQUEST } from "./types";

import AuthService from "../services/authService";
import { LOGIN_ROUTE } from "../routes";

export const login = (data) => async (dispatch) => {
  dispatch({ type: LOGIN_REQUEST });
  try {
    const res = await AuthService.login(data);

    if (res.data.data.token) {
      localStorage.setItem("user", JSON.stringify(res.data));
    }
    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: LOGIN_FAIL,
      payload: err.response.data.message,
    });
  }
};

export const logout = () => (dispatch) => {
  AuthService.logout();

  dispatch({
    type: LOGOUT,
  });
};
